module.exports = __webpack_public_path__ + "static/media/cometogether.d89e87ef.mp3";